import { useEffect, useState } from "react";
import api from "../lib/api";

// Module-level cache so the geo/currency lookup happens once per session.
let _cache = null;
let _promise = null;

export function useCurrency() {
  const [ctx, setCtx] = useState(
    _cache || { currency: "USD", symbol: "$", rate: 1, ready: !!_cache }
  );

  useEffect(() => {
    if (_cache) {
      setCtx({ ..._cache, ready: true });
      return;
    }
    if (!_promise) {
      _promise = api
        .get("/geo/currency")
        .then((r) => r.data)
        .catch(() => ({ currency: "USD", symbol: "$", rate: 1 }));
    }
    let active = true;
    _promise.then((d) => {
      _cache = d;
      if (active) setCtx({ ...d, ready: true });
    });
    return () => {
      active = false;
    };
  }, []);

  // Format a USD dollar amount into the detected currency.
  const fmt = (usd, opts = {}) => {
    if (ctx.currency === "INR") {
      return `₹${Math.round(usd * (ctx.rate || 1)).toLocaleString("en-IN")}`;
    }
    const decimals = opts.decimals != null ? opts.decimals : Number.isInteger(usd) ? 0 : 2;
    return `$${usd.toFixed(decimals)}`;
  };

  return { ...ctx, fmt };
}

export default useCurrency;
